import { HomeIcon } from "src/components/ui-icons/menu";

function NoAccess() {
  return (
    <div className="flex flex-col h-[100vh]">
      <div className="px-7.5 py-4 border-b flex items-center gap-2">
        <HomeIcon />
        <p>Главная</p>
      </div>
      <div className='flex flex-col h-full justify-center items-center gap-5'>
        <div className='font-medium text-lg text-[#111928]'>У вас нет доступа к опроснику GOP Стандарты</div>
        <div className='text-sm font-medium text-[#637381]'>Пожалуйста, обратитесь к администратору</div>
      </div>
    </div>
  )
}

export default NoAccess;
